/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, lazy, Suspense, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import JSONData from "./ussaic.json";
import Cookies from "universal-cookie";
import SpinnerLoader from "./Utils/SpinnerLoader";
import { isMobileDevice } from "./Utils/index.js";
import { CookieSetting } from "cookiesetting-component";

const Footer = lazy(() => import("../components/FooterNew/index"));
const PreEventPage = lazy(() => import("./AngelAiCustomPreEvent/index.js"));
const NFT = lazy(() => import("../components/AngelAiCustomPreEvent/NFT/index.js"));

function Home() {
  const imgPath = process.env.REACT_APP_CDN_ANNUAL_PARTY;
  const isMobile = isMobileDevice();

  const [webpageData, setWebpageData] = useState();
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const cookies = new Cookies(null, { path: "/" });
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showEventPage, setShowEventPage] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const hashKey = searchParams.get("nft");
  const [guestData, setGuestData] = useState(null);
  const [validHashKey, setValidHashKey] = useState(false);


  useEffect(() => {
    // Get the current URL in lowercase
    const lowercaseUrl = window.location.href.toLowerCase();

    // Check if the current URL is in lowercase
    if (window.location.href !== lowercaseUrl) {
      // Redirect to the lowercase URL
      window.location.href = lowercaseUrl;
    }
  }, []);

  useEffect(() => {
    const fetchJSONData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_CDN_LINK + "ussaic/ussaic.json?t=" + Date.now()
        );
        if (response.data && Object.keys(response.data).length > 0) {
          setWebpageData(response.data);
        } else {
          setWebpageData(JSONData);
        }
      } catch (error) {
        setWebpageData(JSONData);
      }
    };

    fetchJSONData();
  }, []);

  useEffect(() => {
    async function validateQRCode() {
      setLoading(true);
      if (!hashKey) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.post(
          process.env.REACT_APP_VALIDATE_QR_CODE,
          { key: hashKey }
        );

        if (res.data !== "Invalid QR Code") {
          setGuestData(res.data);
          setValidHashKey(true);
        }
      } catch (err) {

      }
      setLoading(false);
    }

    validateQRCode();
  }, [hashKey]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 20) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount


  return (
    <>
    <CookieSetting 
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      {loading ?
        <SpinnerLoader />
        :
        <Suspense fallback={<SpinnerLoader />}>
          {webpageData && validHashKey && guestData && (
            <Suspense fallback={<SpinnerLoader />}>
              <NFT
                // themeId={themeId}
                // eventType={eventType}
                // eventCreatedUnderDomain={eventCreatedUnderDomain}
                // eventPageData={eventPageData}
                isMobile={isMobile}
                showOtherComponents={showOtherComponents}
                hashKey={hashKey}
                webpageData={webpageData}
               guestData={guestData}
              />
            </Suspense>
          )}
          {!validHashKey && !guestData && webpageData  && (
            <Suspense fallback={<SpinnerLoader />}>
              <PreEventPage
                // guestData={webpageData.guestData}
                // themeId={webpageData.preEvent.theme}
                // eventType={webpageData.eventType}
                // eventCreatedUnderDomain={webpageData.eventCreatedUnderDomain}
                webpageData={webpageData}
                // preEventData={webpageData.preEvent}
                // postEventData={webpageData.postEvent}
                isMobile={isMobile}
              />

            </Suspense>
          )}
        </Suspense>
     }

    </>
  );
}
export default Home;


